import { useState, useCallback } from "react";
import {
  Box,
  Button,
  Grid,
  Typography
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import RefreshIcon from "@material-ui/icons/Refresh";

import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";

const columnModel = [
  {
    dataField: "Loja",
    text: "Loja",
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "UrlFoto",
    text: "Foto do produto",
    align: "center",
    headerAlign: "center",
    isDummyField: true,
    formatter: (cell, row) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImagePlaceholder
          src={row.UrlFoto}
          alt="Foto do produto"
          width={50}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row.CodigoProduto}`}
        />
      </div>
    ),
    csvExport: true,
  },
  {
    dataField: "Marca",
    text: "Marca",
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Linha",
    text: "Linha",
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "CodigoProduto",
    text: "Código",
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Descricao",
    text: "Descrição",
    align: "left",
    headerAlign: "center",
  },
  {
    dataField: "Ean",
    text: "EAN",
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "QuantidadeEstoque",
    text: "Qtd. Estoque",
    align: "center",
    headerAlign: "center",
  },
];

const useStyles = makeStyles(componentStyles);

export default function TableEstoque({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  searchEstoque,
  toggleUploadDialog,
}) {
  const classes = useStyles();
  const [searching, setSearching] = useState(false);

  const doSearch = useCallback(
    (page, sizePerPage) => {
      setSearching(true);

      searchEstoque({}, page, sizePerPage).then(() => setSearching(false));
    },
    [searchEstoque]
  );

  const refresh = useCallback(() => {
    setSearching(true);

    searchEstoque({}, currentPage, currentSizePerPage).then(() =>
      setSearching(false)
    );
  }, [currentPage, currentSizePerPage, searchEstoque]);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="Id"
      dataTable={dataTable?.map((data, index) => ({ Id: index, ...data }))}
      columnModel={columnModel}
      headerTitle={`Consulta Estoque`}
      csvFileName="ConsultaEstoque.csv"
      showSearch={false}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        totalSize: totalRegistros,
        showTotal: true,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      CustomHeader={() => (
        <Grid
          container
          className="pl-4"
          style={{ height: 60, padding: "0 24px" }}
        >
          <Grid item xs={6} sm={6}>
            <Box component={Typography} variant="h2" marginBottom="0!important">
              <Box component="span">Estoque</Box>
              <IconButtonLoader
                size="medium"
                extraStyle={{
                  width: 24,
                  height: 24,
                  marginLeft: "0.3rem",
                }}
                title="Recarregar lista"
                onClick={refresh}
                icon={<RefreshIcon color="primary" />}
                aria-label="refresh"
                color="primary"
                disabled={searching}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              classes={{
                root: classes.buttonRootWhite,
              }}
              onClick={toggleUploadDialog}
              disabled={searching}
              style={{ display: "flex" }}
              startIcon={
                <Box
                  component="i"
                  fontSize="1.25rem"
                  className="fas fa-file-upload"
                  position="relative"
                />
              }
            >
              Upload
            </Button>
          </Grid>
        </Grid>
      )}
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
      loading={searching}
      notFoundTitle="Sua pesquisa não encontrou nenhum estoque correspondente."
    />
  );
}
